module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAAa0lEQVR4AezSwQkAMRDDwJD+i04HBoE+Ad13jTkmvueDr5+0HinJJC0Bq6dNJmkJWD1tMklLwOppk0laAlZPm0zSErB62iSQnNEkJw84JgmwZjTJyQOOSQKsGU1y8oBjkgBrRpOcPOD4heQDAAD//5Q/aGgAAAAGSURBVAMAOwwAUYQ+jMgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yimou/ic_gs.png
// module id = WGvP
// module chunks = 1